import { Component, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { TranslationService } from 'src/app/common/services/translation.service';

@Component({
  selector: 'taly-sell-with-taly',
  templateUrl: './sell-with-taly.component.html',
  styleUrls: ['./sell-with-taly.component.scss']
})
export class SellWithTalyComponent  implements OnInit {

    transferSignal = inject(SharedSignalsService);
    textDirection: string;
    sliderAmount:any=[];
   
    constructor(public translationService: TranslationService) { 
      effect(() => { 
        this.textDirection = this.transferSignal.textDirection(); 
      });
    }
  
    ngOnInit(): void {
    }
  
  }